import { TenantChildNode } from '@fluentsms/graphql';
import { DrawerOptions } from '../base';

export const convertToDrawerOption = (selectedId?: string) => (node: TenantChildNode): DrawerOptions => {
  return {
    itemId: node.itemId,
    name: node.name,
    selected: node.itemId === selectedId,
  };
};
